import { Component, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectCanManageNotifications } from '@store/selectors/user/user.selectors';
import { HubNotification } from '@models/notification.model';

@Component({
  selector: 'app-notifications-actions-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="actions-container">
      <button class="actionButton" id="viewBtn" mat-mini-fab data-action="view" title="View">
        <mat-icon data-action="view">visibility</mat-icon>
      </button>
      <button *ngIf="canManage && isActive" class="actionButton" id="editBtn" mat-mini-fab data-action="edit" title="Edit">
        <mat-icon data-action="edit">edit</mat-icon>
      </button>
      <button *ngIf="canManage && isActive" class="actionButton" id="deleteBtn" mat-mini-fab data-action="delete" title="Delete">
        <mat-icon data-action="delete">delete</mat-icon>
      </button>
      <button *ngIf="canManage && !isActive" class="actionButton" id="reactivateBtn" mat-mini-fab data-action="reactivate" title="Reactivate">
        <mat-icon data-action="reactivate">restore</mat-icon>
      </button>
    </div>
  `,
  styles: [`
    .actions-container {
      display: flex;
      justify-content: center;
    }
    .actionButton {
      margin: 2px;
      cursor: pointer;
    }
    #viewBtn { background-color: #0099ab; color: white; }
    #editBtn { background-color: #0099ab; color: white; }
    #deleteBtn { background-color: red; color: white; }
    #reactivateBtn { background-color: #0099ab; color: white; }
  `]
})
export class NotificationsActionsRendererComponent implements ICellRendererAngularComp, OnDestroy {
  private readonly store = inject(Store);
  private readonly destroy$ = new Subject<void>();

  canManage = false;
  isActive = true;

  agInit(params: ICellRendererParams): void {
    const notification = params.data as HubNotification;
    this.isActive = notification?.isActive ?? true;

    this.store.select(selectCanManageNotifications)
      .pipe(takeUntil(this.destroy$))
      .subscribe(can => { this.canManage = can; });
  }

  refresh(params: ICellRendererParams): boolean {
    const notification = params.data as HubNotification;
    this.isActive = notification?.isActive ?? true;
    return true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
